import coreStore from "./core-store";
import Axios from 'axios'

const remoteResource = 'account/api/v1/account-balance-items';

const store = coreStore.queryStore(coreStore.createCoreStore('accountBalanceItem', remoteResource));

export default function() { return store };
